import FillRate from 'components/FillRate/FillRate';
import UserFillRatePanel from 'components/UserFillRatePanel/UserFillRatePanel';
import UserFillRate from 'components/UserFillRate/UserFillRate';

import React, { Component } from 'react'
import { Grid, Container, Segment, Dropdown , Popup, Icon} from 'semantic-ui-react';
import './UsersFillRateDashboardContainer.less';
import { getUsersFillRate, getManagerUsers } from 'services/Manager';

const OPEN_FILL_RATE = "OPEN_FILL_RATE"



const initialStates = {
    openedPanel: undefined,
    fillRateFilterDataToShow: '',
    subscriptionRevenueFilterDataToShow: '',
    commissionRevenueFilterDataToShow: "",
    actualRevenueFilterDataToShow: "",
    fillRatesLastDays: 0,
    commissionRevenueLastMonths: 6,
    actualRevenueLastMonths: 6,
    refreshFillRateData: 0,
    fillRateMapDataToShow: "",
    fillRateMapDataModalIsOpen: false,
    fillRateSelectedFilters: { market: {}, category: {} },

    userFillRateData: [],
    userData: [],
    currentLastDaysSelection: {
        value: 0,
        text: "Today"
    },
    dataRefreshingState:false,
    dataRefreshDisabledState:false,
    selectedUser:{}
}


const lastDaysDropdownData = [
    {
        value: 0,
        text: "Today"
    },
    {
        value: 1,
        text: "Yesterday"
    },
    {
        value: 7,
        text: "Last 7 days"
    },
    {
        value: 14,
        text: "Last 14 days"
    },
    {
        value: 30,
        text: "Last 30 days"
    }
]
class UsersFillRateDashboardContainer extends Component {


    constructor(props) {
        super(props);
        this.state = initialStates;
    }

    componentDidMount = () => {
        this.loadData();
    }

    openPanelHandler = (panelName) => {
        this.setState({ openedPanel: panelName })
    }

    fillRateFilterDataToShowHandler = (filterType,selectedUser) => {
        this.setState({
            fillRateFilterDataToShow: filterType , selectedUser: selectedUser
        })
    }

    loadData = async () => {
        // let userData = await getManagerUsers();
        // if(userData.resStatus == 200 )
        // {
        //     this.setState({ userData: userData.data })
        // }
        let response = await getUsersFillRate(this.state.currentLastDaysSelection.value);
        if (response.resStatus == 200) {
            // let selectedUserFound;
            // if(response.data.find((item) => {return item.userID == this.selectedUser.userID}))
            // {
            //     selectedUserFound 
            // }
            this.setState({ userFillRateData: response.data  , dataRefreshingState : false , dataRefreshDisabledState: false })
        }
    }

    onLastDaysChange = (e, data) => {
        // fisrtimeDataLoadState(false)
        this.setState({ currentLastDaysSelection: _.first(_.filter(lastDaysDropdownData, item => item.value == data.value)) },
            () => {
                this.loadData();
            })
        // setCurrentLastDaysSelection(_.first(_.filter(lastDaysDropdownData, item => item.value == data.value)));
        // fillRateLastDaysHandler(data.value)
    }

    refreshData = () => {
        // setDataRefreshDisabledState(true);
        // setDataRefreshingState(true)
        this.setState({dataRefreshingState : true , dataRefreshDisabledState:true})
        setTimeout(() => {
            this.loadData();
            this.handleFillRateRefresh()
        }, 1000);
    }

    handleFillRateRefresh = () => {
        this.setState({ refreshFillRateData: this.state.refreshFillRateData + 1 })
    }

    scrollToUserFillRatePanel = () => {
        if (window.innerWidth > 768) {
            var element = document.getElementById("user-fill-rate-panel-id");
            if (element) {
                console.log(element);
                element.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center'
                });
            }
        }
    }

    render() {
        return (
            <Container fluid className={"user-fill-rate-dashboard-container"}>       
                <div className="main-page-panel">
                    <div className="content-panel">
                            <div className="mobile-header mobile-header-new">
                                <div className="main-heading main-heading-new">
                                    Fill Rate
                                </div>
                            </div>
                        <Segment>
                            <Grid>
                                <Grid.Row className={"fill-rates-filters-row"}>
                                    <Grid.Column width={4} className={"fill-rate-col"}>
                                        <Dropdown fluid name="lastDays" key="act-sub-fil-lastdays"
                                            selection
                                            options={lastDaysDropdownData}
                                            value={this.state.currentLastDaysSelection.value}
                                            text={this.state.currentLastDaysSelection.text}
                                            onChange={this.onLastDaysChange}
                                        ></Dropdown>
                                    </Grid.Column>
                                    <Grid.Column textAlign={"right"} width={1} >
                                        <Popup position={"bottom center"} content='Refresh' trigger={<Icon
                                            onClick={() => { this.refreshData() }}
                                            loading={this.state.dataRefreshingState}
                                            size="large"
                                            disabled={this.state.dataRefreshDisabledState}
                                            circular
                                            //size='small' 
                                            //inverted 
                                            //color='blue' 
                                            name='refresh'
                                        />} />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Segment>

                        {
                            this.state.userFillRateData && this.state.userFillRateData.length ?
                                <Segment>
                                    <Grid>
                                        {/* <Grid.Row className={"fill-rates-row"}>
                                    {
                                        this.state.userData && this.state.userData.length ?
                                            this.state.userData.map((userData) => {
                                                return <Grid.Column width={4} className={"fill-rate-col"}>
                                                    <UserFillRate userData={userData} lastDays={this.state.currentLastDaysSelection.value}/>
                                                </Grid.Column>
                                            })
                                            : ""
                                    }
                                </Grid.Row> */}

                                        <Grid.Row className={"fill-rates-row"}>
                                            {
                                                this.state.userFillRateData.map((userData) => {
                                                    return <Grid.Column width={4} className={"fill-rate-col"} key={`user-fill-rate-box-${userData.userID}`}>
                                                        <UserFillRate scrollToUserFillRatePanel={this.scrollToUserFillRatePanel} selectedUser={this.state.selectedUser} filterDataToShowHandler={this.fillRateFilterDataToShowHandler} filterDataToShow={this.state.fillRateFilterDataToShow} openPanel={() => { this.openPanelHandler(OPEN_FILL_RATE) }} userData={userData} lastDays={this.state.currentLastDaysSelection.value} />
                                                    </Grid.Column>
                                                })
                                            }
                                        </Grid.Row>

                                        <Grid.Row>
                                            <Grid.Column width={16} key={`user-fill-rate-panel-key`} id={"user-fill-rate-panel-id"}>
                                                {
                                                    this.state.openedPanel == OPEN_FILL_RATE
                                                    &&
                                                    <div>
                                                        <UserFillRatePanel selectedUser={this.state.selectedUser} handleFillRateSelectedFilters={this.handleFillRateSelectedFilters} handleFillRateMapModalOpen={this.handleFillRateMapModalOpen} handleFillRateMapDataToShow={this.handleFillRateMapDataToShow} refreshData={this.state.refreshFillRateData} lastDays={this.state.currentLastDaysSelection.value} key={"fill-rate-panel-key"} fillRateFilterDataToShow={this.state.fillRateFilterDataToShow}></UserFillRatePanel>
                                                    </div>
                                                }
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Segment>
                                : ""
                        }
                    </div>
                </div>
            </Container>
        )
    }
}

export default UsersFillRateDashboardContainer
